"use client";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { AppSize, pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";

export default function Hero() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.heroTitle}>
        Building Excellence, One Project at a Time
      </Typography>
      <Typography className={classes.heroDes}>
        From property development to investment consulting, we provide
        high-quality real estate solutions designed to meet your needs
      </Typography>
      <Box className={classes.imgCont}>
        <Image
          src="/images/about/Arel Interior.svg"
          fill
          objectFit="cover"
          alt="Arel Home Interior"
        />
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: theme.spacing(4),
    height: pxToRem(1000),
    backgroundColor: AppColors.neutral["120"],
    paddingTop: pxToRem(40),
    width: "100%",
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `0px ${pxToRem(20)}`,
      height: pxToRem(700),
    },
  },
  heroTitle: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(60),
    fontWeight: 700,
    width: "50%",
    lineHeight: "120%",
    textAlign: "center",
    [theme.breakpoints.down("lg")]: {
      width: "78%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(35),
      width: "104%",
    },
  },
  imgCont: {
    position: "relative",
    height: pxToRem(634),
    width: "100%",
    borderRadius: pxToRem(24),
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: pxToRem(300),
      width: "100%",
    },
  },
  heroDes: {
    fontWeight: 400,
    width: "45%",
    textAlign: "center",
    color: AppColors.text.second,
    fontSize: pxToRem(20),
    lineHeight: "160%",
    [theme.breakpoints.down("lg")]: {
      width: "72% ",
    },
    [theme.breakpoints.down("md")]: {
      width: "100% ",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100% ",
      fontSize: pxToRem(20),
    },
  },
  image: {
    paddingBottom: pxToRem(40),
  },
}));
